import EndpointCard from '../EndpointCard';
import ParamTable from '../ParamTable';
import CodeBlock from '../CodeBlock';

export default function CurrencyAdvancedSection() {
  return (
    <>
      <EndpointCard
        id="candles"
        method="GET"
        path="/api/currency/candles"
        description="Historical OHLC candles over a date range."
      />
      <ParamTable
        title="Query Parameters"
        params={[
          { field: 'base', type: 'string', required: true, description: 'Base currency code' },
          { field: 'quote', type: 'string', required: true, description: 'Quote currency code' },
          { field: 'start_date', type: 'string', required: true, description: 'Start date (YYYY-MM-DD)' },
          { field: 'end_date', type: 'string', required: true, description: 'End date (YYYY-MM-DD)' },
        ]}
      />
      <CodeBlock
        language="json"
        code={`{
  "base": "USD",
  "quote": "EUR",
  "start_time": "2026-03-01",
  "end_time": "2026-03-18",
  "candles": [{
    "start_time": "2026-03-01T00:00:00Z",
    "open": { "midpoint": 0.9210 },
    "close": { "midpoint": 0.9215 },
    "average": { "midpoint": 0.9213 },
    "high": { "midpoint": 0.9225 },
    "low": { "midpoint": 0.9205 }
  }],
  "count": 18
}`}
      />

      <EndpointCard
        id="historical"
        method="GET"
        path="/api/currency/historical"
        description="Historical daily exchange rates for a date or date range."
      />
      <ParamTable
        title="Query Parameters"
        params={[
          { field: 'base', type: 'string', required: true, description: 'Base currency code' },
          { field: 'quotes', type: 'string', required: true, description: 'Quote currency code(s)' },
          { field: 'date', type: 'string', required: false, description: 'Specific date (YYYY-MM-DD)' },
          { field: 'start', type: 'string', required: false, description: 'Range start date' },
          { field: 'end', type: 'string', required: false, description: 'Range end date' },
        ]}
      />
      <CodeBlock
        language="json"
        code={`{
  "base": "USD",
  "date": "2026-03-15",
  "quotes": {
    "EUR": { "date": "2026-03-15", "bid": 0.9218, "ask": 0.9222, "midpoint": 0.9220 }
  }
}`}
      />

      <EndpointCard
        id="forward"
        method="GET"
        path="/api/currency/forward"
        description="Forward exchange rates by tenor (e.g. 1 week, 1 month, 3 months)."
      />
      <ParamTable
        title="Query Parameters"
        params={[
          { field: 'base', type: 'string', required: true, description: 'Base currency code' },
          { field: 'quote', type: 'string', required: true, description: 'Quote currency code' },
        ]}
      />
      <CodeBlock
        language="json"
        code={`{
  "base": "USD",
  "quote": "EUR",
  "rates": [
    {
      "tenor": "1W",
      "spot_midpoint": 0.9220,
      "forward_points_bid": -0.0002,
      "forward_points_ask": -0.0001
    },
    {
      "tenor": "1M",
      "spot_midpoint": 0.9220,
      "forward_points_bid": -0.0008,
      "forward_points_ask": -0.0006
    }
  ],
  "timestamp": "2026-03-18T12:00:00.000Z"
}`}
      />

      <EndpointCard
        id="quota"
        method="GET"
        path="/api/currency/quota"
        description="Check your current OANDA API quota usage."
      />
      <CodeBlock
        language="json"
        code={`{
  "remaining_quotes": 9850,
  "used_quotes": 150
}`}
      />

      <EndpointCard
        id="datasets"
        method="GET"
        path="/api/currency/datasets/:code"
        description="Get information about a specific data source and its available currency pairs."
      />
      <CodeBlock
        language="json"
        code={`{
  "code": "OANDA",
  "description": "OANDA aggregated rates from global liquidity providers",
  "cross_currency": "USD",
  "quotables": ["EUR", "GBP", "JPY", "CHF", "..."]
}`}
      />

      <p className="font-mono text-[10px] text-bone-white/30 uppercase tracking-wider mt-6 mb-2">
        List All Datasets
      </p>
      <CodeBlock
        language="json"
        code={`{
  "datasets": [
    {
      "code": "OANDA",
      "description": "OANDA rates",
      "cross_currency": "USD",
      "quotables_count": 180
    },
    {
      "code": "CRYPTO",
      "description": "Cryptocurrency rates",
      "cross_currency": "USD",
      "quotables_count": 50
    }
  ]
}`}
      />
    </>
  );
}
